import { render } from "./CodeEditor.vue?vue&type=template&id=568c06ea&scoped=true&ts=true"
import script from "./CodeEditor.vue?vue&type=script&lang=ts"
export * from "./CodeEditor.vue?vue&type=script&lang=ts"

import "./CodeEditor.vue?vue&type=style&index=0&id=568c06ea&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568c06ea"]])

export default __exports__